/**
 * GallerySearchDialog Component
 * Placeholder dialog for searching and selecting images from a central gallery.
 * TODO: Implement actual gallery search functionality.
 */
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import { Collections as GalleryIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface GallerySearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (imageUrl: string, imageFile?: File) => void;
}

export const GallerySearchDialog: React.FC<GallerySearchDialogProps> = ({
  open,
  onClose,
  onSelect,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t('actions.pictureSource.galleryTitle')}</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: 8,
            color: 'text.secondary',
          }}
        >
          <GalleryIcon sx={{ fontSize: 64, mb: 2, opacity: 0.5 }} />
          <Typography variant="h6" gutterBottom>
            {t('actions.pictureSource.galleryComingSoon')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t('actions.pictureSource.galleryDescription')}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  );
};
